const dataTableLanguageUrl = "/js/datatables/sv_SE.json";

export function initializeStandardDataTables() {
    // Only run on .data-table elements that don't have specific class initializers
    const genericTables = $('.data-table').not('.delsites-table, .billing-rows-table, .installations-table');
    if (!genericTables.length || genericTables.hasClass('dt-initialized')) {
        return;
    }
    
    // Custom sort for checkbox in first column
    $.fn.dataTable.ext.order['dom-checkbox-first-column'] = function (settings, colIndex) {
        return this.api()
            .column(colIndex, {order: 'index'})
            .nodes()
            .map(td => {
                const checkbox = $('input[type="checkbox"]', td);
                return checkbox.length > 0 ? (checkbox.prop('checked') ? 0 : 1) : $(td).text();
            });
    };

    const table = $(".data-table").DataTable({
        language: {url: dataTableLanguageUrl},
        paging: true,
        processing: true,
        serverSide: false,
        responsive: false,
        stateSave: true,
        scrollX: false,
        pageLength: 50,
        columnDefs: [
            {targets: 0, orderDataType: 'dom-checkbox-first-column'}
        ],
        layout: {
            topStart: [
                'pageLength',
                {buttons: ['excel']}
            ],
        }
    });

    table.tables().every(function () {
        const dataTable = this;

        $(dataTable.table().node()).closest('form').on('submit', function () {
            const form = this;

            $(form).find('input.dt-hidden-row-input').remove();

            dataTable.$('input[type="checkbox"]:checked').each(function () {
                if (!document.contains(this)) {
                    $('<input>', {type: 'hidden', class: 'dt-hidden-row-input', name: this.name, value: this.value}).appendTo(form);
                }
            });
        });
    });

    function applyTabindexToRows() {
        table.rows({page: 'current'}).every(function () {
            const $node = $(this.node());
            if (!$node.hasClass('child')) {
                $node.attr('tabindex', 0);
            }
        });
    }

    // Initial tabindex setup
    applyTabindexToRows();

    // Reapply tabindex on draw (e.g., pagination)
    table.on('draw', function () {
        applyTabindexToRows();
    });

    // Keyboard navigation & checkbox toggling
    document.addEventListener('keydown', function (e) {
        const rows = [...document.querySelectorAll('.data-table tbody tr[tabindex="0"]')];
        const currentIndex = rows.findIndex(r => r === document.activeElement);

        // ↓ Down arrow
        if (e.key === 'ArrowDown' && currentIndex >= 0 && currentIndex < rows.length - 1) {
            e.preventDefault();
            rows[currentIndex + 1].focus();
        }

        // ↑ Up arrow
        if (e.key === 'ArrowUp' && currentIndex > 0) {
            e.preventDefault();
            rows[currentIndex - 1].focus();
        }

        // Spacebar = toggle checkbox in focused row
        if (e.key === ' ' && currentIndex >= 0) {
            e.preventDefault();
            const checkbox = rows[currentIndex].querySelector('input[type="checkbox"]');
            if (checkbox) {
                checkbox.checked = !checkbox.checked;
                $(checkbox).trigger('change');
            }
        }

        // Ctrl+A or Cmd+A = toggle all checkboxes
        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'a') {
            e.preventDefault();
            const checkboxes = document.querySelectorAll('.data-table tbody input[type="checkbox"]');
            const allChecked = [...checkboxes].every(cb => cb.checked);
            checkboxes.forEach(cb => {
                cb.checked = !allChecked;
                $(cb).trigger('change');
            });
        }
    });
}
